import React from 'react'
import clsx from 'classnames'
import moment from 'moment'
import { APIService } from 'api/APIService'
import { useFetch } from 'src/hooks/useFetch'
import { parseHtml } from 'utils/htmlParserWithCustomLinks'
import { Loader } from 'components/Utility/Loader/Loader'
import styles from './Gifts.module.scss'

const fetchGifts = () => APIService.profile.fetchGifts()

const formatDate = (date: string) => moment(date).format('DD.MM.YYYY')

/** The «Мои подарки» tab: gift programmes and the gifts received in each */
export const Gifts: React.FC = () => {
  const { response, isLoading } = useFetch(fetchGifts)

  if (isLoading || !response.result) {
    return <div className={styles.root}><Loader /></div>
  }

  return (
    <div className={styles.root}>
      <div className={styles.iconContainer}>
        <div className={styles.stars}>
          <div className={clsx([styles.giftIconContainer, styles.circleBorderContainer])}>
            <div className={clsx([styles.giftIcon, styles.circleBorderContent])} />
          </div>
        </div>
      </div>
      <div className={styles.giftsContainer}>
        {response.result.map((gift, index) => (
          <div key={index} className={styles.level}>
            <div className={styles.levelTitle}>
              <div className={clsx([styles.circle, styles.checkmark, gift.discounts?.length > 0 && styles.active])} />
              <div>
                {gift.program.name}
              </div>
            </div>
            <div className={clsx([styles.levelDescr, 'text-content'])}>
              {parseHtml(gift.program.description)}
            </div>
            <div className={styles.issuedContainer}>
              {gift.discounts?.map((discount, discountIndex) => (
                <div key={discountIndex}>
                  {discountIndex + 1}. Получен{' '}
                  {formatDate(discount.issuedAt)}
                  {discount.expiresAt !== null ? ', истекает ' + formatDate(discount.expiresAt) : ''}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
